<template>
  <b-progress v-bind="$props">
    <slot></slot>
    <template v-if="$slots.bar" #bar>
      <slot name="bar"></slot>
    </template>
  </b-progress>
</template>

<script>
import { ProgressBarFormat } from '@/modules/core/app/enums/progressbar/ProgressBarFormat';
import { ProgressBarSize } from '@/modules/core/app/enums/progressbar/ProgressBarSize';
import { ProgressBarType } from '@/modules/core/app/enums/progressbar/ProgressBarType';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ProgressView',
  slotsDefinition: {
    bar: {}
  },
  props: {
    type: {
      type: String,
      default: ProgressBarType.IS_DARKGREY,
      validator(value) {
        return Object.values(ProgressBarType).includes(value);
      }
    },
    size: {
      type: String,
      validator(value) {
        return Object.values(ProgressBarSize).includes(value);
      }
    },
    rounded: {
      type: Boolean,
      default: true
    },
    value: {
      type: Number,
      default: undefined
    },
    max: {
      type: Number,
      default: 100
    },
    showValue: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: ProgressBarFormat.RAW,
      validator(value) {
        return Object.values(ProgressBarFormat).includes(value);
      }
    },
    precision: {
      type: Number,
      default: 2
    },
    keepTrailingZeroes: {
      type: Boolean,
      default: false
    },
    locale: {
      type: [String, Array],
      default: undefined
    }
  }
};
</script>
